enum TreatmentType {
  rateBased = "Rate Based",
  volumeBased = "Volume Based",
  na = "NA"
}

export default TreatmentType;
